import { functions } from '../firebase';
import { httpsCallable } from 'firebase/functions';

interface GeocodingResult {
  latitude: number;
  longitude: number;
}

export const geocodingService = {
  geocodeAddress: async (address: {
    street: string;
    city: string;
    postalCode: string;
  }): Promise<GeocodingResult> => {
    try {
      const geocodeAddressFn = httpsCallable<{ address: typeof address }, GeocodingResult>(
        functions,
        'geocodeAddress'
      );

      const result = await geocodeAddressFn({ address });
      if (
        !result.data ||
        typeof result.data.latitude !== 'number' ||
        typeof result.data.longitude !== 'number'
      ) {
        throw new Error('Nieprawidłowa odpowiedź geokodowania.');
      }
      return result.data;
    } catch (error) {
      console.error('Błąd podczas geokodowania adresu:', error);
      throw error;
    }
  },
};
